import {
    CHANGE_REF_BIKE_LEAD_REQUEST,
    CHANGE_REF_BIKE_LEAD_REQUEST_SUCCESS,
    CHANGE_REF_BIKE_LEAD_REQUEST_FAILURE,
    UPDATE_BIKE_LEAD_UPGRADES_SUCCESS, UPDATE_BIKE_LEAD_UPGRADES_REQUEST,
} from '../constants/get_lead_profile.constants';

export const changeRefBikeLeadRequest = (_id, key, value, lead_id) => ({
    type: CHANGE_REF_BIKE_LEAD_REQUEST, _id, key, value, lead_id,
});
export const changeRefBikeLeadRequestSuccess = (key, data) => ({ type: CHANGE_REF_BIKE_LEAD_REQUEST_SUCCESS, key, data });
export const changeRefBikeLeadRequestFailure = (error) => ({ type: CHANGE_REF_BIKE_LEAD_REQUEST_FAILURE, error });

export const updateBikeLeadUpgradesRequest = () => ({ type: UPDATE_BIKE_LEAD_UPGRADES_REQUEST });
export const updateBikeLeadUpgradesSuccess = (key, data) => ({ type: UPDATE_BIKE_LEAD_UPGRADES_SUCCESS, key, data });



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/redux/actions/change_ref_bike_lead.actions.js